"use strict";

module.exports = function () {
  return Math.ceil(this.count / this.limit);
};